import { render, staticRenderFns } from "./Replica.vue?vue&type=template&id=7e57a21a&"
import script from "./Replica.vue?vue&type=script&lang=js&"
export * from "./Replica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e57a21a')) {
      api.createRecord('7e57a21a', component.options)
    } else {
      api.reload('7e57a21a', component.options)
    }
    module.hot.accept("./Replica.vue?vue&type=template&id=7e57a21a&", function () {
      api.rerender('7e57a21a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/Replica.vue"
export default component.exports